/* Cuestionario estandar */

//*react- recursos
import React, { useState } from "react";
import { Form, Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
//import base64 from  'react-native-base64';

//*componentes-utiles
//import VentanaObjError from "../../../componentes/VentanaObjError";

//*clases
import "../componentes.css"

//*archivos (imagenes y elementos necesarios para la rutina)
//import { Checkbox } from '@reactjscomponentrepository/frontend-components/lib/components';

//*api's (servicios y store)

//*store's

//*componente
export default function Autenticar() {
  //*store's

  //*datos: mis etiquetas

  /* const misEtiquetas = [
      {id: 0, desc: "Iniciar sesión"},
      {id: 1, desc: "Usuarios de prueba"},
      {id: 2, desc: "Usuario"},
      {id: 3, desc: "Contraseña"},
      {id: 4, desc: "<div class='color-blue-1'>Dominio de pruebas</div><div>La <strong>información</strong> alojada en el dominio <strong>no es resguardada</strong>, ya que sus fines son exclusivamente para el <strong>entrenamiento</strong> y <strong>capacitación</strong> del uso de la plataforma <strong>AAIE_DGIAI</strong></div>"}
    ]; */

  //*constantes y variables
  const nameOptions = [
    { text: "Services", value: "Services" },
    { text: "Retail", value: "Retail" },
  ];

  //*useState
  const [checkC, setCheckC] = useState(false);

  //*useEffect

  //*funciones
  /*  onChange = (e:any, { name, value }) => {
    this.setState({ [name]: value });
  };  */

  //*vista
  return (
    <div  className="container container-Vista">
       <h1>Ejemplo de cuestionario*</h1>
      <label >
           Generado por medio de formik, es importante agregar configurarValidaciones();  en app.js <br/>
           Aquí no se llama componente especial, todo se genera en esta página  <br/> <br/>
      </label>
      <div className="container-Componente" >
        <br/>
        {" "}
        {/* homeFather */}
        <div className="background-color-white">
          {" "}
          {/* homeChild */}
          <br />
          <br />
          <Formik
            initialValues={{
              nombre: "",
              email: "",
              numero: "",
              texto: "",
              industry: "",
              checkb1: false,
              checkb2: false,
              radiob: "",
            }}
            onSubmit={async (values) => {
              let usuario = values.nombre;
            }}
            validationSchema={Yup.object({
              nombre: Yup.string().required("Campo requerido").letras(),
              email: Yup.string().required("Campo requerido").email(),
              numero: Yup.string().required("Campo requerido").numeros(),
              texto: Yup.string()
                .required("Campo requerido")
                .min(5, "Deben ser mínimo 5 caracteres")
                .max(15, "Deben ser máximo 15 caracteres"),
              industry: Yup.string()
                .required("Debe seleccionar una opción")
                .select(),
              checkb1: Yup.bool().oneOf([true], "Requerido"),
              checkb2: Yup.bool().oneOf([true], "Requerido"),
              radiob: Yup.string().required("Debe seleccionar una opción"),
            })}
          >
            {({ values, setFieldValue }) => (
              <Form className="mx-4">
                <div className="form-group">
                  {/*Input text nombre*/}
                  <label htmlFor="nombre">Nombre</label>
                  <Field
                    type="text"
                    name="nombre"
                    className="form-control text-center mb-3"
                    placeholder="nombre"
                  />
                  <ErrorMessage name="nombre">
                    {(mensaje) => (
                      <span className="">
                        <div className="alert alert-warning heigth-1">
                          <div className="margin-top-1">{mensaje}</div>
                        </div>
                      </span>
                    )}
                  </ErrorMessage>
                  {/*Input text email*/}
                  <label htmlFor="email">email</label>
                  <Field
                    type="text"
                    name="email"
                    className="form-control text-center mb-3"
                    placeholder="email"
                  />
                  <ErrorMessage name="email">
                    {(mensaje) => (
                      <span className="">
                        <div className="alert alert-warning heigth-1">
                          <div className="margin-top-1">{mensaje}</div>
                        </div>
                      </span>
                    )}
                  </ErrorMessage>
                  {/*Input text numeros*/}
                  <label htmlFor="numero">numeros</label>
                  <Field
                    type="text"
                    name="numero"
                    className="form-control text-center mb-3"
                    placeholder="numero"
                  />
                  <ErrorMessage name="numero">
                    {(mensaje) => (
                      <span className="">
                        <div className="alert alert-warning heigth-1">
                          <div className="margin-top-1">{mensaje}</div>
                        </div>
                      </span>
                    )}
                  </ErrorMessage>
                  {/*textarea*/}
                  <label htmlFor="texto">textarea</label>
                  <Field
                    name="texto"
                    as="textarea"
                    className="TextArea"
                    placeholder="texto"
                    maxlength="25"
                  />
                  <ErrorMessage name="texto">
                    {(mensaje) => (
                      <span className="">
                        <div className="alert alert-warning heigth-1">
                          <div className="margin-top-1">{mensaje}</div>
                        </div>
                      </span>
                    )}
                  </ErrorMessage>
                  <br />
                  <br />
                  {/* Select */}
                  <label htmlFor="industry">select</label>
                  <Field
                    id="industry" // remove onBlur warning
                    name="industry"
                    className="selectCues"
                    as="select"
                    value={values.industry}
                    options={nameOptions}
                    onChange={(e: any) =>
                      setFieldValue("industry", e.target.value)
                    }
                  >
                    <option key={0} value="Seleccionar" label="Seleccionar" />
                    {nameOptions.map((np: any, index: any) => (
                      <option
                        key={index + 1}
                        value={np.value}
                        label={np.value}
                      />
                    ))}
                  </Field>
                  <ErrorMessage name="industry">
                    {(mensaje) => (
                      <span className="">
                        <div className="alert alert-warning heigth-1">
                          <div className="margin-top-1">{mensaje}</div>
                        </div>
                      </span>
                    )}
                  </ErrorMessage>
                  <br />
                  <br />
                  <label>checkbox</label>
                  <br />
                  <div style={{ display: "inline-flex" }}>
                    <Field type="checkbox" name="checkb1" className="chkCues" />
                    <label htmlFor="checkb1" className="espc">
                      Uno
                    </label>
                    <ErrorMessage name="checkb1">
                      {(mensaje) => (
                        <span className="">
                          <div className="alert alert-warning heigth-1">
                            <div className="margin-top-1">{mensaje}</div>
                          </div>
                        </span>
                      )}
                    </ErrorMessage>
                  </div>
                  <br />
                  <div style={{ display: "inline-flex" }}>
                    <Field type="checkbox" name="checkb2" className="chkCues" />
                    <label htmlFor="checkb2" className="espc">
                      Dos
                    </label>

                    <ErrorMessage name="checkb2">
                      {(mensaje) => (
                        <span className="">
                          <div className="alert alert-warning heigth-1">
                            <div className="margin-top-1">{mensaje}</div>
                          </div>
                        </span>
                      )}
                    </ErrorMessage>
                  </div>

                  <br />
                  {/* radio */}
                  <label htmlFor="radiob">radioButton</label>
                  <br />
                  <div style={{ display: "inline-flex" }}>
                    <Field type="radio" name="radiob" value="One" />
                    <span className="espc">One</span>
                  </div>
                  <br />
                  <div style={{ display: "inline-flex" }}>
                    <Field type="radio" name="radiob" value="Two" />
                    <span className="espc">Two</span>
                  </div>
                  <ErrorMessage name="radiob">
                    {(mensaje) => (
                      <span className="">
                        <div className="alert alert-warning heigth-1">
                          <div className="margin-top-1">{mensaje}</div>
                        </div>
                      </span>
                    )}
                  </ErrorMessage>

                  <button type="submit" className="btn-login mt-5 mb-5">
                    Aceptar
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
        <br/>
      </div>
    </div>
  );
}
